<template>
  <g>
    <path d="M10 4a6 6 0 110 12 6 6 0 010-12zm0 .5a5.5 5.5 0 100 11 5.5 5.5 0 000-11z" fill-rule="nonzero" />
    <path
      d="M13.16 7l.34.5-1.47.75L13.5 9l-.34.5-1.96-1.02c-.13-.09-.2-.16-.2-.23s.05-.13.16-.2l2-1.05zM6.84 7l-.34.5 1.47.75L6.5 9l.34.5L8.8 8.48c.13-.09.2-.16.2-.23s-.05-.13-.16-.2L6.84 7z"
    />
    <path
      d="M13.26 11.25H6.75v.25c0 .52.07.93.2 1.24a3.33 3.33 0 003.04 2.01 3.15 3.15 0 003.25-3.02l.02-.48zm-.53.5v.1a2.65 2.65 0 01-2.73 2.4 2.83 2.83 0 01-2.6-1.7l-.03-.12a2.48 2.48 0 01-.1-.56l-.01-.12h5.47z"
      fill-rule="nonzero"
    />
    <path
      d="M8.13 12.3a5.4 5.4 0 00-.1 1.74c.1.75.29 1.2.61 1.6.33.4.73.66 1.37.66.63 0 1.03-.2 1.38-.65.34-.45.52-.95.6-1.61.04-.44-.02-1.02-.18-1.74a15.2 15.2 0 01-3.68 0z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PlaceholderIcon",
});
</script>
